/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * In diesem Dialog wird eine List von Websites angezeigt. 
 * Wählt der Benutzer eine Website aus, dann wird die entsprechende Website
 * in einem externen Webbrowser geöffnet.
 * 
 * Im 'Admin'-Modus kann die Liste der Websites verwaltet werden.  
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import LanguageIcon from '@material-ui/icons/Language';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import { ModalTitle } from "../../partials/ModalTitle";

import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as settingActions from "../../../store/actions/settingActions";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

class WebsiteModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'WebsiteModal'

        this.debug = false;

        this.state = {
            websites: [],
            validationError: false,
            validationMessage: "",
        }

        this.agGridRightApi = null;
        this.agGridRightColumnApi = null;
        this.agGridRightWidth = 400;
        this.agGridRightVisibleItems = 5;

        this.agGridRowHeight = 40;
        this.agGridHeaderHeight = 40;

        this.timestamp = 0;
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidMount = () => {
        const { settingList } = this.props.setting;

        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Mount`);
        debug && console.log(`##################################################\n\n`);

        const newWebsites = [];
        settingList?.websites.map((d) => newWebsites.push(d));
        this.setState({ websites: newWebsites });
    }

    componentDidUpdate(prevProps) {
        const { modalDialog, windowWidth } = this.props.app;
        const { settingList } = this.props.setting;

        this.agGridRightWidth = windowWidth * 1;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {

            const newWebsites = [];
            settingList?.websites.map((d) => newWebsites.push(d));
            this.setState({ websites: newWebsites });
        }
    }

    componentWillUnmount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Unmount`);
        debug && console.log(`##################################################\n\n`);
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, appModus, currentContainer } = this.props.app;
        const { validationError, websites } = this.state;

        if (websites.length === 0) return null;

        const onCancel = () => {
            this.props.closeModalDialog(); // appAction.js
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderWebsiteListUser = () => {
            const onClick = (url) => {
                this.props.closeModalDialog(); // appAction.js

                cordova.viewWebsite(url)
            }

            return (
                <List>
                    {websites.map(website => (
                        <ListItem button onClick={() => onClick(website.url)} key={website.title}>
                            <ListItemAvatar>
                                <Avatar>
                                    <LanguageIcon fontSize='large' />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={website.title} />
                        </ListItem>
                    ))}
                </List>
            )
        }

        const renderWebsiteListAdmin = () => {

            // Allgemeine AG-Grid Konfiguration
            const defaultColDef = {
                sortable: false,
                editable: false,
                filter: false,
                resizable: false,
                enableValue: false,
                enableRowGroup: false,
                enablePivot: false
            }

            // Spalten konfigurieren    
            const columnsDefsRight = [
                {
                    headerName: "Titel",
                    field: "title",
                    cellStyle: (params) => { return { textAlign: 'left' } },
                    width: this.agGridRightWidth * .4,
                    editable: true,
                    rowDrag: true,
                },
                {
                    headerName: "Link",
                    field: "url",
                    width: this.agGridRightWidth * .4,
                    cellStyle: (params) => { return { textAlign: 'left' } },
                    editable: true,
                },
                {
                    headerName: "",
                    field: "action",
                    width: this.agGridRightWidth * .1,
                    type: 'rightAligned',
                    editable: false,
                    cellRenderer: "actionRenderer",
                }
            ];

            // Inizalisierung
            const onGridRightReady = (params) => {
                this.agGridRightApi = params.api;
                this.agGridRightColumnApi = params.columnApi;
                params.api.sizeColumnsToFit();
            }

            // callbacks
            const onChange = (d) => {
                //console.log('onChange()', d);
            }

            const onCellClicked = (event) => {
                //console.log('onCellClicked()', event);
            }

            const renderActionColumn = (d) => {

                const onDelete = (event) => {
                    this.timestamp = new Date().getTime();

                    let newWebsites = this.state.websites;
                    newWebsites.splice(event.rowIndex, 1);
                    this.setState({ websites: newWebsites });
                }

                return (
                    <div><DeleteIcon onClick={() => onDelete(d)} /></div>
                )
            }

            // ###############################################################
            // renderDetailList()
            // ###############################################################
            const height = this.agGridRightVisibleItems * this.agGridRowHeight + this.agGridHeaderHeight + 1;

            return (
                <div key={this.timestamp} className="w-full ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridWebsites"
                        onGridReady={onGridRightReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsRight}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={websites}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"single"}
                        rowMultiSelectWithClick={false}
                        onRowDragEnd={onChange}
                        onCellValueChanged={onChange}
                        rowDragManaged={true}
                        onCellClicked={onCellClicked}

                        // Header
                        headerHeight={this.agGridHeaderHeight}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        // cell renderer
                        frameworkComponents={{
                            actionRenderer: renderActionColumn
                        }}
                    />
                </div>
            )
        }

        const renderActions = () => {

            const onSave = () => {
                this.props.updateSetting('websites', this.state.websites);

                // ModalDialog beenden
                this.props.setModalDialog(null, null)
            }

            const onAdd = () => {
                this.timestamp = new Date().getTime();

                let newWebsites = this.state.websites;
                newWebsites.push({ title: 'neue website', url: "" });
                this.setState({ websites: newWebsites });
            }

            return (
                <DialogActions>
                    <Button onClick={onAdd} variant="contained" color="primary" startIcon={<AddIcon />} >Neu</Button>
                    <div className="flex-grow"></div>
                    <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                    <Button onClick={onSave} variant="contained" color="primary" disabled={validationError}>OK</Button>
                </DialogActions>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        if (currentContainer === '') {
            console.log(this.component + ': !currentContainer -> redirect to /\n\n`');
            return <Redirect to='/' />
        }

        if (appModus === 'Admin') {
            return (
                <Dialog fullWidth={true} open={true} maxWidth={'md'}>
                    <ModalTitle onClose={onCancel}>Websites</ModalTitle>
                    <DialogContent dividers>
                        {renderWebsiteListAdmin()}
                    </DialogContent>
                    {renderActions()}
                </Dialog>
            )
        } else {
            return (
                <Dialog fullWidth={false} open={true} maxWidth={'md'}>
                    <ModalTitle onClose={onCancel}>Websites</ModalTitle>
                    <DialogContent dividers>
                        {renderWebsiteListUser()}
                    </DialogContent>
                </Dialog>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        setting: state.setting,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteModal);